import { IMockProps, ErrorResponseCodeType } from '_core/types';
import { ENDPOINT_API_PATH, CODE_ERRORS } from '../Definitions/GeoDef';

type ParamsType = {
  type: string;
  input?: string;
  address?: string;
  placeId?: string;
};

const autoGenerateSuccess = (params: ParamsType) => {
  const getlocationSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      body: null,
      params,
    },
    configResponse: {
      status: 200,
      data: [],
    },
  };
  return getlocationSuccess;
};

const autoGenerate = (params: ParamsType) => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            type: params.type,
            input: `${index}-${params.input}`,
          },
          body: null,
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateResponseAutoComplete = autoGenerateSuccess({
  type: 'autocomplete',
  input: '30310-110',
});
const autoGenerateResponseDetail = autoGenerateSuccess({
  type: 'detail',
  placeId: 'ChIJFR-lEyMCz5QRjWFy92Z4498',
});
const autoGenerateResponseGeolocation = autoGenerateSuccess({
  type: 'geolocation',
  address: '-22.250250,-49.921820',
});

const generatedSuccessMocks = [
  autoGenerateResponseAutoComplete,
  autoGenerateResponseDetail,
  autoGenerateResponseGeolocation,
];

const autoGenerateErrorsMock = () => {
  const errorPartner = autoGenerate({
    type: 'autocomplete',
    input: '30310-110',
  });
  return [...errorPartner];
};

const errorsGenerated = autoGenerateErrorsMock();

const Mocks = [...generatedSuccessMocks, ...errorsGenerated];

export default Mocks;
